import React, { useState } from 'react';
import Progress from './Progress';
import StepX from './StepX';
import StepTasks from './StepTasks';
import StepComment from './StepComment';
import StepWallet from './StepWallet';
import StepSubmit from './StepSubmit';

export default function WhitelistInline() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({ x: "", proofOfComment: "", walletEth: "" });
  const [timestamp] = useState(Date.now());
  

  const next = () => setStep(s => s + 1);
  const prev = () => setStep(s => s - 1);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Bangers&family=Nunito:wght@700;800;900&display=swap" rel="stylesheet" />
      <style>{`
        .wl-btn-primary:hover { filter: brightness(1.07); }
        .wl-btn-primary:active { transform: skewX(-4deg) translateY(5px) !important; box-shadow: 0 2px 0 #7A4A00 !important; }
        .wl-btn-back:active { transform: translateY(3px) !important; box-shadow: 0 2px 0 #7A4A00 !important; }
        .wl-task-row:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(61,31,10,0.25) !important; }
        .wl-input:focus { outline: none; border-color: #C87400 !important; box-shadow: 0 0 0 3px rgba(200,116,0,0.2), inset 0 2px 4px rgba(0,0,0,0.1) !important; }
      `}</style>

      <div style={{
        width: '100%', height: '100%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '32px 20px', boxSizing: 'border-box',
      }}>
        <div style={{
          width: '100%', maxWidth: '500px',
          background: 'linear-gradient(160deg, #F5EDD6 0%, #EDE0C0 100%)',
          borderRadius: '20px',
          padding: '32px 28px 24px',
          boxShadow: '0 16px 0 #7A4A00, 0 20px 40px rgba(61,31,10,0.55)',
          border: '4px solid #3D1F0A',
          position: 'relative',
          overflow: 'hidden',
          boxSizing: 'border-box',
        }}>
          {/* Gold top banner */}
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: '6px',
            background: 'linear-gradient(90deg, #C87400, #D4A017, #FFC94A, #D4A017, #C87400)',
            borderRadius: '16px 16px 0 0',
          }} />

          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '6px', position: 'relative' }}>
            <span style={{
              fontFamily: "'Bangers', cursive",
              fontSize: '13px', letterSpacing: '4px',
              color: '#C87400', textTransform: 'uppercase',
            }}>
              🐑 THE EID SHEEP 🐑
            </span>
            <h1 style={{
              fontFamily: "'Bangers', cursive",
              fontSize: '30px', letterSpacing: '2px',
              color: '#3D1F0A', margin: '2px 0 0',
              textShadow: '2px 2px 0 rgba(200,116,0,0.3)',
            }}>
              WHITELIST FORM
            </h1>
          </div>

          <Progress step={step} totalSteps={5} />

          {step === 1 && <StepX form={form} handleChange={handleChange} next={next} />}
          {step === 2 && <StepTasks form={form} next={next} prev={prev} />}
          {step === 3 && <StepComment form={form} handleChange={handleChange} next={next} prev={prev} />}
          {step === 4 && <StepWallet form={form} handleChange={handleChange} next={next} prev={prev} />}
          {step === 5 && <StepSubmit form={form} timestamp={timestamp} onSuccess={() => {}} />}

          {/* Footer */}
          <div style={{
            textAlign: 'center', marginTop: '18px', paddingTop: '14px',
            borderTop: '2px dashed rgba(61,31,10,0.2)',
          }}>
            <span style={{
              fontFamily: "'Bangers', cursive",
              fontSize: '18px', color: '#C87400',
              letterSpacing: '2px',
            }}>
              THE EID SHEEP — ETH NFT COLLECTION
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
